// Get Network Merchant Status
export const GET_NETWORK_MERCHANT_STATUS_REQUEST = 'GET_NETWORK_MERCHANT_STATUS_REQUEST';
export const GET_NETWORK_MERCHANT_STATUS_DONE = 'GET_NETWORK_MERCHANT_STATUS_DONE';
export const GET_NETWORK_MERCHANT_STATUS_FAILED = 'GET_NETWORK_MERCHANT_STATUS_FAILED';
export const GET_NETWORK_MERCHANT_STATUS_NOT_CONNECTED = 'GET_NETWORK_MERCHANT_STATUS_NOT_CONNECTED';

// Set Network Merchant Rate
export const SET_NETWORK_MERCHANT_RATE_REQUEST = 'SET_NETWORK_MERCHANT_RATE_REQUEST';
export const SET_NETWORK_MERCHANT_RATE_DONE = 'SET_NETWORK_MERCHANT_RATE_DONE';
export const SET_NETWORK_MERCHANT_RATE_FAILED = 'SET_NETWORK_MERCHANT_RATE_FAILED';

// Set Network Merchant Locking Window
export const SET_NETWORK_MERCHANT_LOCKING_WINDOW_REQUEST = 'SET_NETWORK_MERCHANT_LOCKING_WINDOW_REQUEST';
export const SET_NETWORK_MERCHANT_LOCKING_WINDOW_DONE = 'SET_NETWORK_MERCHANT_LOCKING_WINDOW_DONE';
export const SET_NETWORK_MERCHANT_LOCKING_WINDOW_FAILED = 'SET_NETWORK_MERCHANT_LOCKING_WINDOW_FAILED';

// Request Network Activation
export const REQUEST_NETWORK_ACTIVATION_REQUEST = 'REQUEST_NETWORK_ACTIVATION_REQUEST';
export const REQUEST_NETWORK_ACTIVATION_DONE = 'REQUEST_NETWORK_ACTIVATION_DONE';
export const REQUEST_NETWORK_ACTIVATION_FAILED = 'REQUEST_NETWORK_ACTIVATION_FAILED';
